import { render } from "./SelectInputFromQuery.vue?vue&type=template&id=1bca67e0&ts=true"
import script from "./SelectInputFromQuery.vue?vue&type=script&lang=ts"
export * from "./SelectInputFromQuery.vue?vue&type=script&lang=ts"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__